<template>
	<div class="slider__outer slider__outer-stories">
		<div ref="swiper" class="swiper slider slider--stories">
			<div class="swiper-wrapper slider__wrapper">
				<div class="swiper-slide slider__slide" v-for="(post,idx) in items" :key="idx">
					<story-teaser
						:title="post.title"
						:link="post.link"
						:image-sizes="getImageSizes(post)"
						:person-name="post.name"
						:person-function="post.function">
					</story-teaser>
				</div>
			</div>
	
			<div class="slider__pagination js-pagination">
			</div>
		</div>
	</div>
</template>

<script>
// import Swiper core and required modules

// Import Swiper Vue.js components

import Swiper, { Pagination } from 'swiper';
import Icon from './Icon.vue';
import StoryTeaser from './StoryTeaser.vue';
// Import Swiper styles
import 'swiper/swiper-bundle.min.css';

export default {
	name: "StoryTeasersSlider",
	components: {
	  Icon,
	  StoryTeaser
	},
	data() {
		return {
			items: [],
			activeIndex: 0,
		};
	},
	methods: {
		onSwiper (swiper) {
			console.log(swiper)
		},
		onSlideChange () {
			console.log('slide change')
		},

        // Return array with urls of the default and retina image
        getImageSizes(post) {
            let sizes = [];

			if(post.image) {
				sizes.push(post.image);
			}

			if(post.image_retina) {
				sizes.push(post.image_retina);
			}

            return sizes;
        },
		offset() {
			const offset = window.innerWidth * 0.075;

			return offset;
		},

		offsetTablet() {
			const offset = window.innerWidth * 0.05;

			return offset;
		},
		

	},
	props: ['stories'],
	mounted: function(){
		const swiper = this.$refs.swiper;

		this.items = JSON.parse(this.stories);

		this.$nextTick()
			.then(() => {
				new Swiper(swiper, {
					modules: [Pagination],
					loop: false,
					autoHeight: true,
					pagination: {
						el: '.js-pagination',
						type: 'bullets',
						clickable: true
					},
					spaceBetween: 0,
					centered: true,
					breakpoints: {
						// when window width is >= 640px
						768: {
							slidesPerView: 2.25,
							spaceBetween:32,
							slidesOffsetAfter: this.offset(),
							slidesOffsetBefore: this.offset(),
						}
					},
					on: {
						slideChange: (swiper) => {
							this.activeIndex = swiper.realIndex
						},
					},
				});
			});
	}
};
</script>

<style scoped>
	.swiper {
		min-height: 300px;
	}

	.swiper-slide {
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>

